import { KioskState } from ".";
import ActionTypes from "../actions/actionTypes";

const initialState = {
  state: KioskState.init,
  callB: null,
  externalReference: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SIP_REGISTER_SUCCESS:
      return { ...state, state: KioskState.ready };

    case ActionTypes.SIP_CALLING:
      return {
        ...state,
        state: KioskState.calling,
        callB: action.payload.callBName,
      };

    case ActionTypes.SIP_CALL_REJECTED_REMOTE:
      return { ...state, state: KioskState.rejectedRemote };

    case ActionTypes.SIP_CALL_TERMINATED_REMOTE:
      return { ...state, state: KioskState.terminatedRemote };

    case ActionTypes.SIP_CALL_TERMINATED_LOCAL:
      return { ...state, state: KioskState.terminatedLocal };

    case ActionTypes.SIP_CALL_ACCEPTED_REMOTE:
      return { ...state, state: KioskState.acceptedRemote };

    case ActionTypes.SIP_CALL_COMPLETED:
      return { ...state, state: KioskState.callCompleted };

    case ActionTypes.CALL_TO_UNREGISTERED:
      return { ...state, state: KioskState.unregisteredNumber };

    case ActionTypes.USER_LOGIN_FAILED:
      return { ...state, state: KioskState.wrongUsernamePassword };

    case ActionTypes.USER_LOGIN_FAILED_TOKEN_INVALID:
      return { ...state, state: KioskState.tokenInvalid };

    case ActionTypes.USER_LOGIN_FAILED_TOKEN_EXPIRED:
      return { ...state, state: KioskState.tokenExpired };

    default:
      break;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/kiosk/kioskReducer.js